import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";
import { createStore } from "../storeHelper";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:VesselCatalogItemStore`);

const DEFAULT_EDITOR = {};

const DEFAULT_COLLECTION_EDITOR = {
  name: null,
  description: null,
  organisationId: null,
};

export const useVesselCatalogItemStore = defineStore(
  "vesselCatalogItem",
  createStore({
    state: {
      editor: sureClone(DEFAULT_EDITOR),
    },

    getters: {
      // No getters in original
    },

    actions: {
      newCatalogItemToEditor() {
        this.set("editor", sureClone(DEFAULT_EDITOR));
      },

      newCollectionToCatalogItemEditor() {
        this.set("editor.collection", sureClone(DEFAULT_COLLECTION_EDITOR));
      },

      async createCatalogItem() {
        const catalogItem = sureClone(this.editor);
        debug("createCatalogItem", catalogItem);
        const response = await ApiClient.post("/catalogItems", catalogItem);
        debug("createCatalogItem - response", response);

        if (response.collection) {
          // Cross-store commit to vessels
          const { useVesselsStore } = await import("./vessels");
          const vesselsStore = useVesselsStore();
          vesselsStore.addVessel(response.collection);
        }

        return response;
      },

      async deleteCatalogItemByCollectionId(collectionId) {
        debug("deleteCatalogItemByCollectionId", collectionId);
        const result = await ApiClient.delete(
          `/catalogItems?collectionId=${encodeURIComponent(collectionId)}`,
        );
        debug("deleteCatalogItemByCollectionId result", result);

        // Cross-store commit to vessels
        const { useVesselsStore } = await import("./vessels");
        const vesselsStore = useVesselsStore();
        vesselsStore.deleteVessel(collectionId);

        return result;
      },
    },
  }),
);
